export default __webpack_public_path__ + "static/media/no-photo.efbd1d75.png";